
import { defineComponent } from '@nuxtjs/composition-api'
import { setupTranslationPrefixer } from '~/assets/translation'

export default defineComponent({
  props: {
    templateName: { type: String, required: false, default: undefined },
    title: { type: String, required: false, default: undefined },
    introduction: { type: String, required: false, default: undefined },
    overview: { type: Object, required: false, default: undefined },
    entries: { type: Array, required: true, default: () => [] },
  },
  setup() {
    return {
      ...setupTranslationPrefixer('matrix-project-spotlight'),
    }
  },
  data() {
    return {
      tinySliderOptions: {
        fixedWidth: 254,
        responsive: {
          760: {
            edgePadding: 50,
          },
          1024: {
            edgePadding: 80,
          },
        },
      },
      darkTheme: this.templateName === 'homePage',
    }
  },
})
